import "./BlogHero.css";

const BlogHero = () => {
  return (
    <section className="blog-hero">

      <div className="blog-hero-grid"></div>

      <div className="blog-hero-content">

        <span className="blog-hero-badge">
          ● TECH AND DIGITAL INSIGHTS
        </span>

        <h1>
          Insights That Help You Build Better
          <span> Digital Experiences</span>
        </h1>

        <p>
          Explore practical insights, trends, and ideas across web development,
          mobile apps, software, game development, and emerging technologies.
        </p>

      </div>

    </section>
  );
};

export default BlogHero;